import { useCallback } from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetTwoFactorConf = () => {
    const send = useGenericSend();
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async (): Promise<Types.IGetTwoFactorConfResponseData> => {
        const { data } = await send<{casino: string}, Types.IGetTwoFactorConfResponseData>({
            ID: 35757,
            casino: casinoName,
            description: 'Get Two Factor Conf',
            responses: [35758, 35759]
        });

        return data;
    }, [send, casinoName]);
};
